// Single browser-safe game version constant shared by hooks and analytics.
export const GAME_VERSION = '0.0.0-m0';
